$(function () {

    /**
     * This jQuery extension is used to animate a DOM move operation of an element.
     *
     * Usage example: $("#elementToMove").parentToAnimate($("#targetParent"), 'append', '200');
     * ... to move #elementToMove to new parent #targetParent by appending to end of target with speed of 200ms.
     */

    jQuery.fn.extend({

        parentToAnimate: function (destination, mode, speed) {
            mode = mode || "append";
            speed = speed || "slow";

            var $element = $(this);

            destination = $(destination);
            var sourceOffset = $element.offset();
            var sourceWidth = $element.css("width");

            if (mode === "append") {
                $(this).appendTo(destination);
            } else if (mode === "prepend") {
                $(this).prependTo(destination);
            }

            var targetOffset = $element.offset();
            var targetWidth = $element.css("width");

            var temp = $element.clone().appendTo("body");

            temp.css({
                "position": "absolute",
                "width": sourceWidth,
                "left": sourceOffset.left,
                "top": sourceOffset.top,
                "zIndex": 1000
            });

            $element.hide();

            temp.animate({
                "top": targetOffset.top,
                "left": targetOffset.left,
                "width": targetWidth
            }, speed, function () {
                $element.show();
                temp.remove();
            });
        }
    });

});
